import { useState } from 'react'
import cn from 'clsx'

import { MdStar, MdStarOutline } from 'react-icons/md'
import IconToggle from '@components/shared/IconToggle/IconToggle'

const ProjectsTable = ({
    className,
    projects,
}) => {
    
    const [foo, setFoo] = useState(false)
    
    return (
        
        <table className={cn('ProjectsTable table-auto', className)}>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>{/* Actions */}</th>
                </tr>
            </thead>
            <tbody>
                {projects.map(project => (
                    <tr key={project.id}>
                        <td>{project.name}</td>
                        <td>{project.description}</td>
                        <td>
                            <div className="flex justify-center items-center gap-2">
                                <IconToggle
                                    iconClassName="text-xl"
                                    title={(foo ? 'Remove from' : 'Add to') + ' favorites'}
                                    checked={foo}
                                    onChange={() => {
                                        setFoo(!foo)
                                        console.log('@todo update', project)
                                    }}
                                    OnIcon={MdStar}
                                    OffIcon={MdStarOutline} />
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        
    )
    
}

export default ProjectsTable
